import { render, staticRenderFns } from "./ColumnResizer.vue?vue&type=template&id=2d5c1b0c&scoped=true&lang=pug"
import script from "./ColumnResizer.vue?vue&type=script&lang=ts"
export * from "./ColumnResizer.vue?vue&type=script&lang=ts"
import style0 from "./ColumnResizer.vue?vue&type=style&index=0&id=2d5c1b0c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5c1b0c",
  null
  
)

export default component.exports